import { Account, AccountType } from '@mews-commander/data-access';
import { getFullName, getReversedFullName } from '@mews-commander/utils';

interface AccountNameProps {
    account: Account;
    reverse?: boolean;
}

export const AccountName: React.FC<AccountNameProps> = ({ account, reverse }) => {
    switch (account.data.discriminator) {
        case AccountType.Company:
            return <>{account.data.value.name}</>;
        case AccountType.Customer:
            return <>{reverse ? getReversedFullName(account.data.value) : getFullName(account.data.value)}</>;
        default:
            throw new Error('Not supported Account Type');
    }
};
